/* Mirrors backend/utils/page_copy.py FIELDS — used as the initial value so pages never flash empty while the admin overrides load. */
export const PAGE_COPY_DEFAULTS = {
  teacher_feedback: {
    title: 'Teacher Feedback',
    tab_requests: 'My requests',
    tab_reviews: 'Teacher reviews',
    tab_history: 'Credit history',
    tab_calls: '1-on-1 calls',
    wallet_kicker: 'Your feedback credits',
    wallet_note: 'These are feedback credits for teacher reviews and 1-on-1 calls — not money and not the same as wallet credits (CA$).',
    buy_label: 'Buy credits',
    exams_label: 'Request on a mock test',
    calls_label: 'Book a 1-1 call',
    wallet_howto: 'Click Request on a mock test, pick the test and the section (or the full test) — done. A teacher watches your answers and records a personal video for you, usually within 12 to 24 hours. If a request is declined, the credits come straight back.',
    free_kicker: 'Pro feature',
    free_title: 'Personal teacher feedback is part of CELPIPMax Pro',
    free_body: 'Pro students get {welcome_credits} feedback credits on day one — enough for a teacher to review one section of a mock test with a personal video — and can book 1-1 calls.',
    free_cta: 'Upgrade to Pro',
    requests_free_note: 'Feedback requests are available on the Pro plan.',
    reviews_empty_title: 'No teacher reviews yet',
    reviews_empty_body: 'When a teacher publishes remarks on one of your mock tests they show up here and on your dashboard.',
    history_free_note: 'Credit history is available on the Pro plan.',
    free_bullets: 'A real CELPIP teacher reviews your Writing, Speaking, Reading or Listening\nPersonal video feedback within 12 to 24 hours — every word explained\nPrivate 1-on-1 calls with a teacher\n{welcome_credits} feedback credits included on day one',
    results_title: 'Want a real teacher to check your test?',
    results_body: 'You have {balance} credits. A {label} review costs only {cost}.',
    results_pitch: 'A teacher will watch your answer and make a video just for you. They will go over every word. You will get it in 12 to 24 hours. The video will show you what you did wrong, why your score is stuck, and how to do better next time.',
    results_waiting: 'Your {label} review is with a teacher. They are going over every word of your answer and recording your video. You will get it in 12 to 24 hours — we will e-mail you and it will show up here.',
    results_delivered: '{teacher} reviewed your {label}. Watch your video and read the remarks on your answers below.',
    results_free: 'Personal video feedback from a real CELPIP teacher is part of CELPIPMax Pro.',
  },
  group_classes: {
    title: 'Group Classes',
    tab_classes: 'Group classes',
    tab_calls: '1-on-1 calls',
    tab_recordings: 'Recordings',
    intro: 'Live classes with your instructor happen right here inside CELPIPMax — open a class and tap Join class here when the room opens (30 minutes before the start). Add it to your calendar or browse upcoming sessions below.',
    locked_title: 'This class is for Pro members',
    locked_body: '“{title}” is part of the CELPIPMax Pro plan.',
    locked_bullets: 'Unlimited live group classes\nFull access to all mock exams + AI scoring\nAll courses + writing & speaking feedback',
    locked_cta: 'Upgrade to Pro',
    locked_dismiss: 'Maybe later',
    calls_title: 'Private 1-on-1 call with a teacher',
    calls_sub: '{cost} feedback credits per call · cancel ≥ {cancel_hours} h before for a full refund · times shown in {tz}',
    calls_free_title: '1-on-1 calls with a CELPIP teacher are a Pro feature',
    calls_free_body: 'Pro students book a private {cost}-credit call straight from this tab and get feedback credits included on day one.',
    calls_free_cta: 'Upgrade to Pro',
    calls_upcoming_heading: 'Your upcoming call',
    calls_available_heading: 'Available times',
    calls_empty: 'No open slots right now — your teacher publishes new times every week. Check back soon.',
    calls_book_title: 'Book this call?',
    calls_earlier_heading: 'Earlier',
    recordings_intro: 'Class recordings your teacher has shared. Watch them here — there is nothing to download or install.',
    recordings_empty: 'No recordings shared yet — they appear here after a live class once your teacher switches them on.',
  },
  whats_included: {
    title: "What's in Pro",
    plan_title_pro: 'You are on CELPIPMax Pro',
    plan_sub_pro: 'Everything below is unlocked until {expires} · {days} days left.',
    plan_title_free: 'You are on the Free plan',
    plan_sub_free: 'Pro unlocks everything below for {period} — one payment, no subscription.',
    plan_upgrade: 'Upgrade to Pro · {price}',
    included_kicker: 'Included in Pro',
    included_title: 'Everything. No limits.',
    included_badge: 'Unlimited use of every feature',
    included_locked: 'Locked on the Free plan.',
    included_locked_link: 'Upgrade to unlock everything',
    credits_kicker: 'The only thing that is counted',
    credits_title: 'Teacher feedback credits',
    credits_text: 'Everything else in Pro is unlimited. Personal feedback from a real CELPIP teacher uses credits: Pro includes {welcome} credits on day one — enough for a teacher to review one section of a mock test and send you a personal video. Buy more any time.',
    cost_section: 'One section of a mock test (Writing, Speaking, Reading or Listening)',
    cost_full: 'Full mock test — all four sections',
    cost_call: 'Private 1-on-1 call with a teacher',
    credits_use_btn: 'Use my credits',
    credits_calls_btn: 'Book a 1-on-1 call',
    credits_upgrade_btn: 'Get Pro + {welcome} credits',
    quick_title: 'Start using it',
    footer: 'Questions about your plan?',
    starthere_title_pro: "What's included in your Pro plan",
    starthere_sub_pro: 'Everything below is unlimited — only teacher feedback uses credits (you start with {welcome}).',
    starthere_title_free: 'What you get with Pro',
    starthere_sub_free: 'Everything below, unlimited, plus {welcome} teacher-feedback credits on day one.',
    starthere_more: 'See everything',
  },
  referral: {
    title: 'Referral Program',
    hero_title: 'Earn {percent}% Lifetime Commission',
    hero_sub: 'Share your referral link. When someone subscribes, you earn {percent}% of every payment they make — forever. No caps, no expiry.',
    code_label: 'Your Referral Code:',
    whatsapp_label: 'Share on WhatsApp',
    share_text: "I've been using this CELPIP practice platform and it's really helping me prepare for the test. Try it out: {link}",
    how_title: 'How It Works',
    step1_title: 'Share Your Link',
    step1_body: 'Send your unique referral link to friends preparing for CELPIP',
    step2_title: 'They Subscribe',
    step2_body: 'When they sign up and subscribe to any Pro plan',
    step3_title: 'You Earn {percent}%',
    step3_body: 'You get {percent}% of every payment they make — for life',
    payout_title: 'Weekly payouts by Interac e-Transfer',
    payout_body: 'Payments from {period_start_day} to {period_end_day} are paid out every {payout_day} ({timezone}). A payment must be at least {blackout_hours} hours old before it is paid — this matches our {blackout_hours}-hour refund policy. Balances under {min_payout} roll over to the next week.',
    nonrefundable_note: "Once a referral commission has been paid out, the referred student's payment is no longer refundable.",
    details_title: 'Where should we send your money?',
    details_body: 'Add the Interac e-Transfer e-mail or phone number and the name on your bank account. We only use it to send your payouts.',
    payouts_title: 'Your payouts',
    payouts_empty: 'No payouts yet — your first one is scheduled after your first referred payment clears the blackout period.',
    history_title: 'Commission History',
  },
};
